import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ListSiteComponent } from './site/list-site/list-site.component';
import { ListPageComponent } from './page/list-page/list-page.component';
import { ListAdUnitComponent } from './adunit/list-adunit/list-adunit.component';

@NgModule({
    imports: [FormsModule, CommonModule, RouterModule],
    declarations: [ListSiteComponent, ListPageComponent, ListAdUnitComponent],
    providers: [],
    exports: [ListSiteComponent, ListPageComponent, ListAdUnitComponent]
})
export class InventorySharedModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/inventory.shared.module.ts